import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/people',
        name: 'people-parent',
        component: () => import('@/pages/people/PeopleIndex.vue'),
        props: true,
        children: [
            {
                name: 'people-index',
                path: '',
                component: () => import('@/components/users/UsersView.vue'),
                meta: {
                    title: 'People',
                    dataTablePage: true,
                    middleware: [GateKeeperMiddleware],
                    // ability: { action: 'view', subject: 'users page' },
                    ability: ({ gateKeeper, to }) => {
                        return (
                            gateKeeper.userHasPermission('view removed course enrollments') ||
                            gateKeeper.userHasGroupPermission('view the users page') ||
                            gateKeeper.userHasPermission('view all users') ||
                            gateKeeper.user.id === Number.parseInt(to.params.personId, 10) ||
                            gateKeeper.userHasGroupPermission('view all users')
                        );
                    },
                },
                props: true,
            },
        ],
    },
    {
        path: '/people/:personId',
        name: 'person-parent',
        component: () => import('@/pages/people/PersonView.vue'),
        children: [
            {
                name: 'person-view',
                path: '',
                component: () => import('@/components/users/UserView.vue'),
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) => {
                        return (
                            gateKeeper.userHasPermission('view a user') ||
                            gateKeeper.user.id === Number.parseInt(to.params.personId, 10)
                        );
                    },
                },
                props: true,
            },
            {
                name: 'person-notifications',
                path: '/people/:personId/notifications',
                component: () => import('@/components/users/UserViewContainer.vue'),
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) => {
                        return (
                            gateKeeper.userHasPermission('view a user') ||
                            gateKeeper.user.id === Number.parseInt(to.params.personId, 10)
                        );
                    },
                    title: 'Notifications',
                },
                props: true,
                beforeEnter: FeatureMiddleware('INBOX'),
            },
            {
                name: 'person-enrollments',
                path: '/people/:personId/enrollments',
                component: () => import('@/components/users/UserViewContainer.vue'),
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) => {
                        return (
                            gateKeeper.userHasPermission('view removed course enrollments') ||
                            gateKeeper.userHasGroupPermission('view removed course enrollments') ||
                            gateKeeper.userHasPermission('view enrollments on profile page') ||
                            gateKeeper.userHasGroupPermission('view enrollments on profile page') ||
                            gateKeeper.user.id === Number.parseInt(to.params.personId, 10)
                        );
                    },
                    title: 'Enrollments',
                },
                props: true,
            },
            {
                name: 'person-ebook',
                path: '/people/:personId/ebooks',
                component: () => import('@/components/users/UserViewContainer.vue'),
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) => {
                        return (
                            gateKeeper.userHasPermission('view a user') ||
                            gateKeeper.userHasGroupPermission('view a user') ||
                            gateKeeper.user.id === Number.parseInt(to.params.personId, 10)
                        );
                    },
                    title: 'Ebooks',
                },
                props: true,
            },
            {
                name: 'person-access',
                path: '/people/:personId/access',
                component: () => import('@/components/users/UserViewContainer.vue'),
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) => {
                        return (
                            gateKeeper.userHasPermission('view removed course enrollments') ||
                            gateKeeper.userHasGroupPermission('view removed course enrollments') ||
                            gateKeeper.user.id === Number.parseInt(to.params.personId, 10)
                        );
                    },
                    title: 'Access',
                },
                props: true,
            },
            {
                name: 'person-risk-assessment',
                path: '/people/:personId/risk-assessment',
                component: () => import('@/components/users/UserViewContainer.vue'),
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) => {
                        return (
                            gateKeeper.userHasPermission('view removed course enrollments') ||
                            gateKeeper.userHasGroupPermission('view removed course enrollments') ||
                            gateKeeper.user.id === Number.parseInt(to.params.personId, 10)
                        );
                    },
                    title: 'Risk Assessment',
                },
                props: { personId: null },
            },
            {
                name: 'person-remediations',
                path: '/people/:personId/remediations',
                component: () => import('@/components/users/UserViewContainer.vue'),
                meta: {
                    title: 'Remediations',
                    middleware: [GateKeeperMiddleware],
                    ability: {
                        action: 'view all',
                        subject: 'remediation processes',
                    },
                },
                props: true,
            },

            {
                name: 'person-grades',
                path: '/people/:personId/grades',
                component: () => import('@/components/users/UserViewContainer.vue'),
                meta: {
                    title: 'Grades',
                    dataTablePage: true,
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        return (
                            gateKeeper.userHasPermission('view all course grade') ||
                            gateKeeper.userHasGroupPermission('view all course grade')
                        );
                    },
                },
                props: true,
            },
        ],
        props: true,
    },
    {
        path: '/me',
        name: 'me-parent',
        component: () => import('@/pages/people/PersonView.vue'),
        props: true,
        children: [
            {
                name: 'me',
                path: '',
                component: () => import('@/components/users/UserView.vue'),
                props: true,
            },
            {
                name: 'my-enrollments',
                path: '/my/enrollments',
                component: () => import('@/components/users/UserViewContainer.vue'),
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) => {
                        return (
                            gateKeeper.userHasPermission('view a user') ||
                            gateKeeper.userHasGroupPermission('view a user') ||
                            gateKeeper.user.id === Number.parseInt(to.params.personId, 10)
                        );
                    },
                    title: 'Enrollments',
                },
                props: { personId: null },
            },
            {
                name: 'my-surveys',
                path: '/my/surveys',
                component: () => import('@/components/users/UserViewContainer.vue'),
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) => {
                        return (
                            gateKeeper.userHasPermission('view a user') ||
                            gateKeeper.userHasGroupPermission('view a user') ||
                            gateKeeper.user.id === Number.parseInt(to.params.personId, 10)
                        );
                    },
                    title: 'Surveys',
                },
                props: { personId: null },
            },
            {
                name: 'my-ebook',
                path: '/my/ebooks',
                component: () => import('@/components/users/UserViewContainer.vue'),
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) => {
                        return (
                            gateKeeper.userHasPermission('view a user') ||
                            gateKeeper.userHasGroupPermission('view a user') ||
                            gateKeeper.user.id === Number.parseInt(to.params.personId, 10)
                        );
                    },
                    title: 'Ebooks',
                },
                props: { personId: null },
            },
            {
                name: 'my-access',
                path: '/my/access',
                component: () => import('@/components/users/UserViewContainer.vue'),
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) => {
                        return (
                            gateKeeper.userHasPermission('view a user') ||
                            gateKeeper.userHasGroupPermission('view a user') ||
                            gateKeeper.user.id === Number.parseInt(to.params.personId, 10)
                        );
                    },
                    title: 'Access',
                },
                props: { personId: null },
            },

            {
                name: 'my-transcript',
                path: '/my/transcript',
                component: () => import('@/components/users/UserViewContainer.vue'),
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) => {
                        return (
                            gateKeeper.userHasPermission('view a user') ||
                            gateKeeper.userHasGroupPermission('view a user') ||
                            gateKeeper.user.id === Number.parseInt(to.params.personId, 10)
                        );
                    },
                    title: 'Transcript',
                },
                props: { personId: null },
            },
            {
                name: 'my-notifications',
                path: '/my/notifications',
                component: () => import('@/components/users/UserViewContainer.vue'),
                meta: {
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) => {
                        return (
                            gateKeeper.userHasPermission('view a user') ||
                            gateKeeper.userHasGroupPermission('view a user') ||
                            gateKeeper.user.id === Number.parseInt(to.params.personId, 10)
                        );
                    },
                    title: 'Notifications',
                },
                props: { personId: null },
                beforeEnter: FeatureMiddleware('INBOX'),
            },
            {
                name: 'my-grades',
                path: '/my/grades',
                component: () => import('@/components/users/UserViewContainer.vue'),
                meta: {
                    title: 'Grades',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper }) => {
                        return gateKeeper.userHasPermission('view a grade');
                    },
                },
                props: true,
            },
        ],
    },
];
